import styled from 'styled-components';

export const RecieptCard = styled.div`
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x4};
`;
export const RecieptCardItm = styled.div`
  &:not(&:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.x3};
  }
`;
export const RecieptCardItmKey = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const RecieptCardItmValue = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
